import { createCrudService } from '@/services/api/createCrudService'

export interface Test {
  id: string
  test: string
  code: string | null
  status: 'ATIVO' | 'INATIVO'
}

export const TestsService = createCrudService<Test>('/workflow/tests', { searchField: 'test' })
